<template>
    <div class="end-page">
        <div v-if="!getIsShow(['1'])"
            class="close-page"
            @click="closeEnd">
            <img class="close-page-img"
                src="../../../../../static/runtime/images/magic/timedDraw/close.png">
        </div>
        <div v-if="isShow" class="end-page-top">
          <!-- 活动已结束，用户有中奖 -->
          <div v-if="getIsShow(['1'])">
            <div class="content-winningPrize">
              <div class="content-winningPrize-title">恭喜您获得</div>
              <div class="content-winningPrize-content"
                  :style="{backgroundImage: 'url(' + drawPointUrl + ')'}">
                  <img class="content-winningPrize-goodsPictureUrl"
                      :src="goodsPictureUrl">
                  <div class="content-winningPrize-text">{{ rewardName }}</div>
                  <div class="content-winningPrize-dec">{{ rewardDescri }}</div>
              </div>
              <div v-if="miniprogramFlag || loginType == 'Alipay'" class="content-winningPrize-buttom"
                  :style="{'background':activityConfig.buttonColor,'color':activityConfig.buttonTextColor}"
                  @click="getGift">立即领取</div>
              <div v-if="!miniprogramFlag && loginType == 'wechat'" class="content-winningPrize-buttom"
                  :style="{'background':activityConfig.buttonColor,'color':activityConfig.buttonTextColor}">
                  立即领取
                  <div class="content-winningPrize-buttom-wechat">
                    <div class="wxOpenLaunchWeapp"
                      v-html="wxOpenLaunchWeappHiHonor"></div>
                  </div>
              </div>
              <div class="content-winningPrize-close-page"
                  @click="closeEnd">
                  <img class="content-winningPrize-close-page-img"
                      src="../../../../../static/runtime/images/magic/timedDraw/close.png">
              </div>
            </div>
          </div>
          <!-- 活动结束后,用户未中奖/活动已结束,但是用户未参与过活动 -->
          <div v-if="getIsShow(['2','3'])">
            <div v-if="getIsShow(['2'])" class="content-unWinning">很遗憾未中奖</div>
            <div v-if="getIsShow(['3'])" class="content-finished">活动已结束</div>
            <div class="content-lottery">恭喜以下<span class="content-lottery-edit">{{ userWinNum }}</span>位中奖用户</div>
            <div class="content-image" :style="{ 'justify-content' : userMessageList.length >= 5 ? 'start' : 'center' }">
              <div v-for="(item,index) in userMessageList"
                :key="index"
                class="content-image-item">
                <div class="content-image-item-img">
                  <img v-if="item.userHeadPortraitUrl"
                    :src="item.userHeadPortraitUrl">
                  <img v-else
                    src="static/runtime/images/magic/award/userImg.png"
                    alt="" />
                </div>
                <div class="content-image-item-text">{{item.anonymizedText}}</div>
              </div>
            </div>
            <div class="content-more"
                :style="{'background':activityConfig.buttonColor,'color':activityConfig.buttonTextColor}"
                @click="goWinnerList">查看更多</div>
          </div>
          <!-- 活动进行中,用户无次数/活动进行中,用户有次数 -->
          <div v-if="getIsShow(['4','5'])">
            <div v-if="['1,2','2','1,4','4'].includes(participateType) && Number(newWinningRate)" class="content-winningRate">
              中奖率<span class="content-winningRate-edit">+{{ newWinningRate }}</span><span v-if="showExceedPercentParticipant">，已超过{{Number(userPercent) > 99 ? 99 : Number(userPercent) }}%的参与者</span>
            </div>
            <div v-if="['1,6','1,6,7','1,7'].includes(participateType) && Number(winningRate)" class="content-winningRate">
              中奖率<span class="content-winningRate-edit">+{{ winningRate }}</span><span v-if="showExceedPercentParticipant">，已超过{{Number(userPercent) > 99 ? 99 : Number(userPercent) }}%的参与者</span>
            </div>
            <div class="content-openingStatus"> 待开奖 </div>
            <div class="content-winnerNumber">已有<span class="content-winnerNumber-edit">{{ userNum }}</span>位用户参与</div>
            <div class="content-image" :style="{ 'justify-content' : userMessageList.length >= 5 ? 'start' : 'center' }">
              <div v-for="(item,index) in userMessageList"
                :key="index"
                class="content-image-item">
                <div class="content-image-item-img">
                  <img v-if="item.userHeadPortraitUrl"
                    :src="item.userHeadPortraitUrl">
                  <img v-else
                    src="static/runtime/images/magic/award/userImg.png"
                    alt="" />
                </div>
                <div class="content-image-item-text">{{item.anonymizedText}}</div>
              </div>
            </div>
            <div v-if="['1,6','1,7','1,6,7'].includes(participateType) && (!helpFlag || Number(remainingSharingTimes) > 0)" class="content-next">
              <div class="content-next-button"
                  :style="{'background':activityConfig.buttonColor,'color':activityConfig.buttonTextColor,'box-shadow': `0px 0px 8px 0px ${activityConfig.buttonColor}`}"
                  @click="closeEnd">
                  {{ buttonValue.ButtonContent }}
              </div>
              <div class="content-next-text">{{ buttonValue.BottomDrawingContent }}</div>
            </div>
            <div class="content-again">
              <div v-if="drawType === 'pointDraw'">
                <div class="content-again-text">{{ drawPointConsumption }}积分/次</div>
                <div class="content-again-text">您剩余积分：{{ balancePonits }}</div>
              </div>
              <div v-if="drawType === 'orderDraw'">
                <div v-if="tips">{{ tips }}</div>
                <div v-else>剩余抽奖次数{{ participateTimes }}次</div>
              </div>
              <div v-if="drawType === 'pointDraw' || drawType === 'orderDraw'" class="content-again-button"
                  :style="{'background':activityConfig.buttonColor,'color':activityConfig.buttonTextColor,'box-shadow': `0px 0px 8px 0px ${activityConfig.buttonColor}`}"
                  @click="showPopupEndPage">再抽一次</div>
            </div>
          </div>
          <!-- 活动已结束,但是活动中奖逻辑还在计算中(开奖中) -->
          <div v-if="getIsShow(['6'])">
            <div class="content-winnerNumber">已有<span class="content-winnerNumber-edit">{{ userNum }}</span>位用户参与</div>
            <div class="content-image" :style="{ 'justify-content' : userMessageList.length >= 5 ? 'start' : 'center' }">
              <div v-for="(item,index) in userMessageList"
                :key="index"
                class="content-image-item">
                <div class="content-image-item-img">
                  <img v-if="item.userHeadPortraitUrl"
                    :src="item.userHeadPortraitUrl">
                  <img v-else
                    src="static/runtime/images/magic/award/userImg.png"
                    alt="" />
                </div>
                <div class="content-image-item-text">{{item.anonymizedText}}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="end-page-top">
          <realOnlineMailingModal ref="realOnlineMailingModal"
            :awardObj="awardObj"
            :isCloseMethods="true"
            :overlayStyle="{'background-color': 'rgba(0,0,0,0)'}"
            @handleRealOnlineMailing="getReceiveData(arguments)"
            @closeEnd="closeEnd"></realOnlineMailingModal>
          <codeCancelAfterVerfication ref="realShopNoAppointment"
            :awardObj="awardObj"
            :codeUrl="awardObj.writeOffCodeUrl"
            :writeOffCode="awardObj.writeOffCode"
            :overlayStyle="{'background-color': 'rgba(0,0,0,0)'}"
            :extendConfigFlag="awardObj.extendConfigFlag"
            :activationCode="awardObj.activationCode"
            :effectiveStartTime="awardObj.effectiveStartTime"
            :effectiveEndTime="awardObj.effectiveEndTime"
            @closeEnd="closeEnd"
            @nextStep="nextStep"
            @getUsedFlag="getUsedFlag"></codeCancelAfterVerfication>
          <virtualOnline ref="virtualOnline"
            :awardObj="awardObj"
            :isReceived="isReceived"
            @handleVirtualOnline="handleVirtualOnline(arguments)"
            @closeEnd="closeEnd"
            @modalCancel="closeEnd"
            @nextStep="nextStep"></virtualOnline>
        </div>
    </div>
</template>
<script>
import wx from "weixin-js-sdk";
import { config as configEnv } from '../../../../commons/config.js';
import { config } from '@/api/config.js';
import realOnlineMailingModal from '../../../../components/modal/real-online-mailing-modal.vue';
import codeCancelAfterVerfication from '../../../../components/modal/code-cancel-after-verification.vue';
import virtualOnline from '../dynamicAttr/modal/virtual-online.vue'
import { Toast } from 'vant';
export default {
  components: {
    [Toast.name]: Toast,
    realOnlineMailingModal,
    codeCancelAfterVerfication,
    virtualOnline
  },
  props: {
    // 结果页（当前页）状态
    endType: {
      type: String,
      default: -1
    },
    // 详细数据
    newBlindBoxData: {
      type: Object,
      default: {}
    },
    // 我的中奖记录
    myRecord: {
      type: Array,
      default: []
    },
    // 每次抽奖需要积分数
    drawPointConsumption: {
      type: Number,
      default: 0
    },
    // 剩余积分
    balancePonits: {
      type: String,
      default: ""
    },
    // 已抽奖次数
    userLotteryNum: {
      type: Number,
      default: 1
    },
    // 超过用户数，和中奖用户数，共用同一个字段
    userNum: {
      type: Number,
      default: 0
    },
    userWinNum:{
      type: Number,
      default: 0
    },
    drawType:{
      type:String,
      default:''
    },
    participateTimes:{
      type:Number,
      default:0
    },
    showExceedPercentParticipant:{
      type:Boolean,
      default:false
    },
    userPercent:{
      type:Number,
      default:0
    },
    newWinningRate:{
      type:Number,
      default: 0
    },
    winningRate:{
      type:Number,
      default: 0
    },
    remainingSharingTimes:{
      type:Number,
      default:0
    },
    activityStatus:{
      type:String,
      default: '1'
    },
    miniprogramFlag:{
      type:Boolean,
      default:true
    },
    activityUrl:{
      type:String,
      default:''
    },
    helpFlag:{
      type:Boolean,
      default:false
    },
    tips: {
      type:String,
      default:''
    }
  },
  computed: {
    buttonValue(){
      const data = {
        ButtonContent:"",
        BottomDrawingContent:""
      }
      if(!this.helpFlag){
        data.ButtonContent = this.activityConfig.helpingButtonContent;
        data.BottomDrawingContent = this.activityConfig.helpingBottomDrawingContent;
      }else{
        if(this.remainingSharingTimes !== 0){
          data.ButtonContent = this.activityConfig.shareButtonContent;
          data.BottomDrawingContent = this.activityConfig.shareBottomDrawingContent;
        }
      }
      return data
    }
  },
  watch: {
    myRecord: {
      handler(){
        if (this.myRecord && this.myRecord.length) {
          if(this.activityStatus === '3'){
            if(JSON.parse(this.myRecord[0]['goodsPictureUrl'])){
              this.goodsPictureUrl = this.$utils.getImageUrl(JSON.parse(this.myRecord[0]['goodsPictureUrl']).file);
            }
            this.rewardDescri = this.myRecord[0]['rewardDescri']
            this.rewardName = this.myRecord[0]['rewardName'];
            this.rewardType = this.myRecord[0]['rewardType'];
            this.collectionType = this.myRecord[0]['collectionType'];
            this.appointmentFlag = this.myRecord[0]['appointmentFlag'];
            this.isReceived = this.myRecord[0]['extendConfigFlag'];
            this.awardObj = this.myRecord[0]
          }
        }
      },
      immediate: true,
    },
    userNum() {
      this.getNewBlindBoxData();
    },
    userWinNum(){
      this.getNewBigwheelWinUserInfo();
    }
  },
  data() {
    return {
      lottery: 20,
      userMessageList: [],
      activityConfig: [],
      drawPointUrl: '', // 获奖背景图
      goodsPictureUrl: '', // 中奖图
      rewardName: '', // 中奖名称
      rewardDescri: '',
      participateType: 1,
      shareEveryDayLimit:0,
      loginType:'',
      wxOpenLaunchWeappHiHonor:'',
      rewardType:null,
      collectionType:null,
      awardObj:{},
      isShow:true,
      appointmentFlag:null,
      isReceived:false, // 线上兑换判断是否兑换字段
      hiHonorWxAppId:config.otherConfig.hiHonorWxAppId,
    };
  },
  created() {
    this.loginType = sessionStorage.getItem('loginType') || '';
    this.activityConfig = this.newBlindBoxData.activityConfig;
    this.participateType = this.activityConfig.participateType;
    if(['1,6','1,6,7'].includes(this.participateType)){
      this.shareEveryDayLimit = this.activityConfig.shareEveryDayLimit;
    }
    if(this.getIsShow(['4','5','6'])){
      this.getNewBlindBoxData();
    }else if(this.getIsShow(['2','3'])){
      this.getNewBigwheelWinUserInfo()
    }
    this.drawPointUrl = this.$utils.getImageUrl(JSON.parse(this.newBlindBoxData.drawPointUrl).file);
    const env = configEnv.env === 'pro' ? 'release' : 'trial';
    if (!this.miniprogramFlag) {
      this.wxOpenLaunchWeappHiHonor = `<wx-open-launch-weapp id="launch-btn" env-version="${env}" username="${this.hiHonorWxAppId}" path="subpackages/my/pages/rewardQuery/reward-query"><template><style>.btn { width: 1000px;height: 300px; opacity: 0;}</style><button class="btn">打开小程序</button> </template> </wx-open-launch-weapp>`
    }
  },
  methods: {
    getNewBlindBoxData() {
      if (this.newBlindBoxData.bigwheelUserInfo && this.newBlindBoxData.bigwheelUserInfo.length) {
        this.userMessageList =
          this.newBlindBoxData.bigwheelUserInfo.map(res => {
            return {
              anonymizedText: res.nickName.anonymizedText.slice(0,4) || '****',
              userHeadPortraitUrl: res.userHeadPortraitUrl
            };
          }) || [];
          this.userMessageList = this.userMessageList.slice(0,5)
      }
    },
    getNewBigwheelWinUserInfo(){
      if (this.newBlindBoxData.bigwheelWinUserInfo && this.newBlindBoxData.bigwheelWinUserInfo.length) {
        this.userMessageList =
          this.newBlindBoxData.bigwheelWinUserInfo.map(res => {
            return {
              anonymizedText: res.nickName.anonymizedText.slice(0,4) || '****',
              userHeadPortraitUrl: res.userHeadPortraitUrl
            };
          }) || [];
          this.userMessageList = this.userMessageList.slice(0,10)
      }
    },
    closeEnd() {
      this.$emit('closeEnd');
    },
    showPopupEndPage() {
      this.$emit('showPopupEndPage');
    },
    getGift(){
      // appointmentFlag 1 预约导购
      // rewardType 奖品类型(0:未中奖,1:虚拟,2:实物,3:优惠券,4:积分,5:代金券,6:赠品券)
      // collectionType 领取类型(1:线上邮寄(实物)/线上兑换(虚拟);2:到店自提(实物)/线下核销(虚拟);3:线下核销发卡密(虚拟);4:门店免单);5:货柜自取
      // usedFlag 使用标识 (0.未领取,1.已领取,2.待领取,3.已预约,4.已核销,5.已免单,6.已过期")
      // extendConfigFlag 是否填写邮寄信息
      if(this.rewardType === '1'){
        setTimeout(async ()=>{
          if(this.appointmentFlag === '1' && (this.collectionType === '2' || this.collectionType === '3')){
            const isNext = await this.getValidity()
            if(isNext){
              this.toAppointmentGuide()
            }
          }else{
            this.isShow = false
            setTimeout(() => {
              if(this.collectionType === '1'){
                // 线上兑换
                this.$refs.virtualOnline.openModel()
              }else if(this.collectionType === '2'){
                // 线下核销
                this.$refs.realShopNoAppointment.openModel();
              }else if(this.collectionType === '3'){
                // 线下核销发卡密
                this.$refs.realShopNoAppointment.openModel();
              }else{
                this.$emit('winningInquiry')
              }
            }, 100);
          }
        },100)
      } else if(this.rewardType === '2'){
        if(this.appointmentFlag === '1' && this.collectionType === '2'){
          this.toAppointmentGuide()
        }else{
          if(this.collectionType === '1'){
            const isNext = this.awardObj.effectiveEndTime ? new Date() > new Date(this.awardObj.effectiveEndTime) : false;
            if(!this.isReceived && isNext){
              Toast('超过领取时间，无法兑换');
              return;
            }
            this.isShow = false
            setTimeout(()=>{
              if(this.awardObj.extendConfig){
                const extendConfig = JSON.parse(this.awardObj.extendConfig)
                extendConfig.userName = this.awardObj.rewardRecordextendConfigPrivacy.userName;
                extendConfig.userPhone = this.awardObj.rewardRecordextendConfigPrivacy.userPhone;
                extendConfig.userAddress = this.awardObj.rewardRecordextendConfigPrivacy.userProvinceName + ' / ' + this.awardObj.rewardRecordextendConfigPrivacy.userCityName + ' / ' + this.awardObj.rewardRecordextendConfigPrivacy.userZoneName;
                extendConfig.userAddressDetail = this.awardObj.rewardRecordextendConfigPrivacy.userAddress;
                this.awardObj = Object.assign(extendConfig, this.awardObj);
              }
              this.$refs.realOnlineMailingModal.openModel();
            },100)
            
          }else if(this.collectionType === '2'){
            this.isShow = false
            setTimeout(() => {
              this.$refs.realShopNoAppointment.openModel();
            }, 50);
          }else{
            this.$emit('winningInquiry')
          }
        }
      } else if (this.rewardType === '3'){
        this.$emit('nextStep',this.awardObj.jumpUrl,this.awardObj.jumpType)
      } else if (this.rewardType === '4'){
        if(this.awardObj.jumpType === "9"){ // 待定PC端字段是否正确
          this.$emit('winningInquiry')
          return
        }
        this.$emit('nextStep',this.awardObj.jumpUrl,this.awardObj.jumpType)
      }else if (this.rewardType === '5'){
        this.$emit('nextStep',this.awardObj.jumpUrl,this.awardObj.jumpType)
      }else if(this.rewardType === '6'){
        // 赠品券
        setTimeout(()=>{
          if(this.appointmentFlag === '1'){
            this.toAppointmentGuide()
          } else{
            this.isShow = false
            setTimeout(() => {
              this.$refs.realShopNoAppointment.openModel();
            }, 100);
          }
        },100)
      }
    },
    goWinnerList(){
      this.$emit('goWinnerList')
    },
    clickToShare(){
      this.$emit('clickToShare')
    },
    getIsShow(data){
      return data.includes(this.endType)
    },
    // 实物线上邮寄领取及后续方法
    getReceiveData(msg){
      const [awardObj,goodsIndex,params] = msg;
      if(!awardObj){
        this.$emit('nextStep',this.awardObj.jumpUrl,this.awardObj.jumpType) // 跳转配置用到，不用父组件则不加
        this.closeEnd()
        return
      }
      params['bigwheelRewardRecodeId'] = awardObj.recordId || awardObj.bigwheelRewardRecodeId;
      this.$api.post({
          sc: "mobileMarketing",
          url: "h5/bigWheel/reward/record/update",
          params: params,
          success: r => {
            if(r.code === 200) {
              Toast('领取成功！');
              setTimeout(() => {
                this.$emit('nextStep',this.awardObj.jumpUrl,this.awardObj.jumpType) // 跳转配置用到，不用父组件则不加
                this.closeEnd()
              }, 1000);
            } else {
              Toast(r.message);
            }
          },
          failure:() => {
              Toast('领取失败！');
          }
      })
    },
    // 虚拟-线上兑换
    handleVirtualOnline(msg){
      const [awardObj,goodsIndex,userName,userPhone] = msg;
      const params = {
        bigwheelRewardRecodeId:awardObj.recordId || awardObj.bigwheelRewardRecodeId,
        userName: userName,
        userPhone: userPhone,
      }
      this.$api.post({
          sc: "mobileMarketing",
          url: "h5/bigWheel/reward/record/update",
          params: params,
          success: r => {
              Toast('领取成功！');
              this.isReceived = true
          },
          failure:() => {
              Toast('领取失败！');
          }
      })
    },
    // 跳转预约导购
    async toAppointmentGuide() {
      const { result } = await this.checkShoppingGuide(this.awardObj.exchangeActivationCodeId);
      this.path = (result && result.guideId)?`subpackages/activity/pages/shoppersService/serviceDetail/service-detail?id=${result.guideId}&activityUrl=${this.activityUrl}`:`subpackages/activity/pages/shoppersService/createService/create-service?activationCodeId=${this.awardObj.exchangeActivationCodeId}&collectionType=${this.awardObj.collectionType}&drawType=${this.drawType}&activityUrl=${this.activityUrl}`
      let url = `/${this.path}`
      const userBase = sessionStorage.getItem("userInfo")
      if(!userBase){
        url += '&refresh=1'
      } else if(!userBase.member){ 
        url += '&refresh=1'
      }
      sessionStorage.setItem("needRefreshPage", true); 
      if(this.loginType === 'wechat'){
        wx.miniProgram.navigateTo({
          url: url,
          success: function() {
            console.log('跳转回小程序的页面success');
          },
          fail: function(res) {
            console.log('跳转回小程序的页面fail', res);
          }
        });
      }else{
        my.redirectTo({
          url: url
        });
      }
      
    },
    //检测是否已经预约成功了
    checkShoppingGuide(id) {
      return new Promise((resolve, reject) => {
        this.$api.get({
          noLoading: true,
          sc: "mobileMarketing",
          url: `guide/getGuideByActivationCodeId/${id}`,
          params: null,
          success: r => {
            resolve(r);
          }
        });
      });
    },
    //
    nextStep(){
      this.$emit('nextStep',this.awardObj.jumpUrl,this.awardObj.jumpType)
      if(this.rewardType === '1' && (this.collectionType === '1' || this.collectionType === '3')) return
      this.closeEnd()
    },
    // 虚拟线下核销发卡密查询是否核销
    getUsedFlag(){
      this.$api.post({
          sc: "mobileMarketing",
          url: `h5/bigWheel/queryWriteOffStatusById/${this.awardObj.exchangeActivationCodeId}`,
          params:{},
          success: r => {
            if(r.result){
              this.awardObj.usedFlag = '4'
            }else{
              Toast('暂未核销，核销后可查看卡密')
            }
          },
          failure:() => {
              Toast('领取失败！');
          }
      })
    },
    // 校验核销码是否在有效期内
    getValidity(){
      return new Promise((resolve,reject)=>{
        this.$api.post({
          noLoading: true,
          sc: "mobileMarketing",
          url: `h5/bigWheel/getWriteOff/${this.awardObj.goodsId}`,
          params: null,
          success: r => {
            if(r.code === Number('200')){
              resolve(true);
            }else{
              // 提示核销码不在有效期
              Toast(r.message)
              resolve(false)
            }
          }
        });
      })
    },
  }
};
</script>
<style scoped lang="scss">
.end-page {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  display: flex;
  justify-content: center;
  backdrop-filter: blur(5px);
  .close-page {
    position: absolute;
    right: 4.1%;
    top: 3.1%;
    width: 24px;
    height: 24px;
    border: 1px solid #ffffff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    .close-page-img {
      width: 12px;
      height: 12px;
      filter: drop-shadow(0 0 white);
    }
  }
  .end-page-top {
    margin-top: 27vh;
    width: 83%;
    text-align: center;
    font-family: HONORSansBrand-DemiBold;
    color: #ffffff;
    font-weight: 600;
    .content-raffleNumber {
      font-size: 30px;
      line-height: 40px;
      margin-bottom: 1.3vh;
    }
    .content-openingStatus {
      font-size: 30px;
      line-height: 40px;
    }
    .content-winnerNumber {
      font-size: 21px;
      font-weight: 500;
      line-height: 36px;
      color: #ffffff;
      margin-top: 1.3vh;
      .content-winnerNumber-edit {
        font-size: 30px;
        font-weight: 700;
      }
    }
    .content-image {
      display: flex;
      width: 85%;
      margin: 0.6vh auto 0;
      flex-wrap: wrap;
      .content-image-item {
        width: 20%;
        margin-top: 1.3vh;
        .content-image-item-img {
          position: relative;
          margin-left: 10%;
          width: 80%;
          height: 0;
          padding-top: 80%;
          border-radius: 50%;
          overflow: hidden;
          img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            overflow: hidden;
          }
        }
        .content-image-item-text {
          margin-top: 1vh;
          height: 16px;
          font-size: 12px;
          font-weight: 200;
          overflow: hidden;
        }
      }
    }
    .content-again {
      margin-top: 15vh;
      .content-agin-text {
        font-size: 14px;
        font-weight: 300;
        line-height: 23px;
      }
      .content-again-button {
        width: 90%;
        height: 6vh;
        line-height: 6vh;
        margin: 2.5vh auto 0;
        font-size: 16px;
        font-weight: 400;
        border-radius: 3vh;
      }
    }
    .content-next{
      margin-top: 2.5vh;
      .content-next-text {
        font-size: 14px;
        font-weight: 400;
        line-height: 23px;
      }
      .content-next-button {
        width: 80%;
        height: 6vh;
        line-height: 6vh;
        margin: 2.5vh auto 1.5vh;
        font-size: 16px;
        font-weight: 400;
        border-radius: 3vh;
      }
    }
    .content-unWinning {
      font-size: 30px;
      line-height: 40px;
    }
    .content-finished {
      font-size: 30px;
      line-height: 40px;
    }
    .content-lottery {
      font-size: 21px;
      font-weight: 500;
      line-height: 36px;
      margin-top: 1.3vh;
      .content-lottery-edit {
        font-size: 30px;
        color: #256fff;
        font-weight: 700;
      }
    }
    .content-notStarted {
      font-size: 30px;
      line-height: 40px;
    }
    .content-winningRate {
      font-size: 19px;
      line-height: 28px;
      font-size: 600;
      margin-bottom: 1.6vh;
      font-family: HONORSansBrand-DemiBold;
      .content-winningRate-edit {
        color: #ffffff;
      }
    }
    .content-more {
      width: 50%;
      height: 5.7vh;
      margin: 3vh auto 0;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: 400;
      border-radius: 2.8vh;
    }
    .content-opening {
      font-size: 30px;
      line-height: 40px;
      margin-bottom: 3.2vh;
    }
    .content-winningPrize {
      margin-top: -10vh;
      .content-winningPrize-title {
        font-size: 30px;
      }
      .content-winningPrize-content {
        width: 88vw;
        height: 39vh;
        margin-top: 1.6vh;
        background-size: 100% 100%;
        .content-winningPrize-goodsPictureUrl {
          width: 25.4vw;
          height: 11.7vh;
          margin: 1.5vh auto 0;
        }
        .content-winningPrize-text {
          font-size: 14px;
          font-weight: 400;
          color: #000000;
          width: 180px;
          margin: 1vh auto 0;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .content-winningPrize-dec{
          color: #256FFF;
          font-size: 12px;
          text-align: center;
          font-weight: 400;
          margin-top: 0.3vh;
        }
      }
      .content-winningPrize-buttom {
        position: relative;
        width: 57.5vw;
        height: 5.8vh;
        margin: 2.1vh auto 0;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 2.9vh;
        .content-winningPrize-buttom-wechat{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
        }
      }
      .content-winningPrize-close-page {
        width: 24px;
        height: 24px;
        margin: 2.4vh auto 0;
        border: 1px solid #ffffff;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        .content-winningPrize-close-page-img {
          width: 12px;
          height: 12px;
          filter: drop-shadow(0 0 white);
        }
      }
    }
  }
}
#launch-btn{
  width: 100%;
  height: 100%;
}
.content-again-button {
  width: 90%;
  height: 6vh;
  line-height: 6vh;
  margin: 2.5vh auto 0;
  font-size: 16px;
  font-weight: 400;
  border-radius: 3vh;
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/timedDraw/endPage.vue